<template>
  <el-dialog
    custom-class="addBusinessClass"
    title="新增企业"
    :visible.sync="dialogVisible"
    width="40%"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="addForm"
      label-width="100px"
      ref="addForm"
      :rules="addFormRules"
      label-position="right"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="企业名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="地区" prop="showname">
            <el-input
              v-model="addForm.showname"
              auto-complete="off"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="大区代号" prop="regionCode">
            <el-select
              v-model="addForm.regionCode"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in regionCodeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="11">
          <el-form-item label="资质等级" prop="grade">
            <el-select
              v-model="addForm.grade"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="企业性质" prop="natrue">
            <el-select
              v-model="addForm.natrue"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in natureList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="11">
          <el-form-item label="用户规模" prop="userScale">
            <el-input
              v-model="addForm.userScale"
              placeholder="请输入"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="客户地址" prop="addressInfo">
            <GisCommon
              :selected="selected"
              :address.sync="addForm.addressInfo"
              @backPram="backPram"
              v-model="addForm.addressInfo"
            ></GisCommon>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="客户经理">
            <SelectCommon
              placeholder="客户经理"
              style="width: 200px"
              :clearable="true"
              apiPath="/tbAdminuser/manageList"
              :keys="{ label: 'name', value: 'id' }"
              :defaultVal="managerAdminuser"
              @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'managerAdminuser')
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="11">
          <el-form-item label="客户成功经理">
            <SelectCommon
              placeholder="客户成功经理"
              style="width: 200px"
              :clearable="true"
              apiPath="/tbAdminuser/list"
              :params="{ type: 3 }"
              :keys="{ label: 'name', value: 'id' }"
              :defaultVal="successfulManager"
              @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'successfulManager')
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="经销商">
            <SelectCommon
              placeholder="经销商"
              style="width: 200px"
              :clearable="true"
              apiPath="/tbAdminuser/list"
              :params="{ type: 4 }"
              :keys="{ label: 'name', value: 'id' }"
              :defaultVal="agencyManager"
              @change="
                (value, datas) =>
                  handleSelectCommonFilter(value, datas, 'agencyManager')
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="11">
          <el-form-item label="客户分级" prop="level" class="ratingClass">
            <el-rate v-model="addForm.level" :max="3"></el-rate>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="企业联系人" prop="linker">
            <el-input
              v-model="addForm.linker"
              placeholder="请输入"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="11">
          <el-form-item label="联系方式" prop="linkerPhone">
            <el-input
              v-model="addForm.linkerPhone"
              placeholder="请输入"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="企业图标">
            <el-upload
              ref="upload"
              :auto-upload="false"
              :on-change="imgPreview"
              class="avatar-uploader"
              :action="upload.postURL"
              :show-file-list="false"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center">
      <el-button @click.native="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click.native="addSubmit" :loading="addLoading"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import {
  API__code,
  API_User,
  API_Urls,
  API_Admin,
  API_Common,
  API__Position,
} from "../../../api/index.js";
import SelectCommon from "@/components/SelectCommon";
import GisCommon from "@/components/GisCommon";
export default {
  data() {
    // 校验企业名称是否唯一
    var validatorCompany = async (rule, value, callback) => {
      if (!this.addForm.name) {
        callback("请输入企业名称");
      } else {
        let res = await this.checkCompany(this.addForm.name);
        !res ? callback("企业名称已存在") : callback();
      }
    };
    let validatorLevel = async (rule, value, callback) => {
      if (value === 0) {
        callback("请选择企业分级");
      } else {
        callback();
      }
    };
    let validatorAddress = async (rule, value, callback) => {
      if (!this.addForm.addressInfo) {
        callback("请输入企业位置");
      } else {
        if (!this.addForm.longitudeAndLatitude) {
          callback("请在GIS地图中确认位置");
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: false,
      addLoading: false,
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010",
      }, // ['110000', '130200', '140100']
      address: "",
      managerAdminuser: "",
      successfulManager:"",
      agencyManager:"",
      addForm: {
        name: "",
        showname: "",
        level: 0,
        natrue: "",
        userScale: "",
        province: "",
        city: "",
        district: "",
        longitudeAndLatitude: "",
        addressInfo: "",
        linker: "",
        linkerPhone: "",
        remarks: "",
      },
      regionCodeList: [
        {
          value: "1",
          label: "华东大区",
        },
        {
          value: "2",
          label: "华北大区",
        },
        {
          value: "3",
          label: "西北大区",
        },
        {
          value: "4",
          label: "华南大区",
        },
        {
          value: "5",
          label: "西南大区",
        },
      ],
      gradeList: [
        {
          value: "1",
          label: "综合甲",
        },
        {
          value: "2",
          label: "公路甲",
        },
        {
          value: "3",
          label: "市政甲",
        },
        {
          value: "4",
          label: "公路市政甲",
        },
        {
          value: "5",
          label: "公路乙",
        },
        {
          value: "6",
          label: "市政乙",
        },
        {
          value: "7",
          label: "公路市政乙",
        },
        {
          value: "9",
          label: "高校",
        },
        {
          value: "10",
          label: "施工单位",
        },
        {
          value: "8",
          label: "其他",
        },
      ],
      natureList: [
        {
          value: "1",
          label: "央企",
        },
        {
          value: "2",
          label: "国企",
        },
        {
          value: "3",
          label: "民营上市",
        },
        {
          value: "4",
          label: "民营",
        },
        {
          value: "5",
          label: "高校",
        },
      ],
      addFormRules: {
        name: [
          { required: true, validator: validatorCompany, trigger: "change" },
        ],
        showname: [
          {
            required: true,
            message: "请输入地区",
            trigger: ["blur", "change"],
          },
        ],
        regionCode: [
          {
            required: true,
            message: "请选择大区代号",
            trigger: ["blur", "change"],
          },
        ],
        grade: [
          {
            required: true,
            message: "请选择资质等级",
            trigger: ["blur", "change"],
          },
        ],
        natrue: [
          {
            required: true,
            message: "请选择企业性质",
            trigger: ["blur", "change"],
          },
        ],
        userScale: [
          {
            required: true,
            message: "请输入用户规模",
            trigger: ["blur", "change"],
          },
        ],
        addressInfo: [
          { required: true, validator: validatorAddress, trigger: "change" },
        ],
        level: [
          {
            required: true,
            validator: validatorLevel,
            trigger: ["blur", "change"],
          },
        ],
      },
      imageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: API_Common.setCompanyPic(), //post地址
        dialogImageUrl: "", // 文件地址
        dialogVisible: false, // 上传文件loading
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1,
        },
      },
      beformAddImg: "",
      editImageUrl: "",
    };
  },
  components: {
    SelectCommon,
    GisCommon,
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {},

  created() {
    this.getCookie();
  },

  methods: {
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
    init() {
      this.dialogVisible = true;
    },
    addSubmit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          // debugger
          if (this.addLoading) return;
          this.addLoading = true;
          if (this.beformAddImg) {
            let _this = this;
            let formData = new FormData();
            formData.append("pic", this.beformAddImg.raw);
            formData.append("token", this.token);
            formData.append("checkCode", this.checkCode);
            formData.append("mode", "save");
            let config = {
              "Content-Type": "multipart/form-data",
            };
            axios
              .post(this.upload.postURL, formData, config)
              .then(function (res) {
                if (res.data.code == API__code.SUCCESS) {
                  _this.addHandler(res.data.data);
                  _this.$refs.upload.clearFiles();
                } else {
                  _this.$message.error(res.data.message);
                  if (res.data.code == 403) {
                    _this.$router.push({ path: "loginAdmin" });
                  }
                  return;
                }
              })
              .catch(function (error) {
                console.log(error);
                return;
              });
          } else {
            this.addHandler();
          }
        }
      });
    },

    addHandler(val) {
      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
      }

      let param = {
        ...this.addForm,
        logoid: newlbtPath,
        showpicid: newId,
        token: this.token,
        checkCode: this.checkCode,
        mode: "save",
        createUser: this.userInfo.id,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.managerAdminuser,
        successfulManager:this.successfulManager,
        agencyManager:this.agencyManager,
        isbinding: 0,
      };
      API_User.addCompanyList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.$emit("getList", 1);
            this.handleClose();
          } else {
            this.$message.error(res.data.message);
            if (res.data.code == 403) {
              this.$router.push({ path: "loginAdmin" });
            }
          }
          this.addLoading = false;
        })
        .catch((err) => {
          this.$message.error("数据丢失，试试重新登陆！");
          this.addLoading = false;
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs["addForm"].clearValidate();
      this.$refs["addForm"].resetFields();
    },
    // 客户经理过滤
    handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    backPram(param) {
      this.addForm.province = JSON.stringify(param.selected.province);
      this.addForm.city = JSON.stringify(param.selected.city);
      this.addForm.district = JSON.stringify(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    },

    // 校验公司名称是否唯一：true唯一 false 不唯一
    checkCompany(name) {
      return API_User.checkCompanyUnique({ name })
        .then((res) => {
          if (res.data.code == 401) {
            return false;
          }
          return true;
        })
        .catch((err) => {
          return true;
        });
    },

    imgPreview(file, fileList) {
      let fileName = file.name;
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        console.log("ile.raw", file.raw);
        this.imageUrl = URL.createObjectURL(file.raw);
        console.log("this.imageUrl", this.imageUrl);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
<style lang="scss">
.addBusinessClass {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0 !important;

  .el-col {
    margin-bottom: 12px;
  }

  .el-dialog__body {
    padding: 30px 50px;
  }

  .ratingClass {
    display: flex;
    align-items: center;

    .el-form-item__content {
      margin-left: 0 !important;
      width: 110px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// targetCustomDialog.vue?0da8413e